<template>
  <section :class="['w-5/6 lg:w-7xl mx-auto flex flex-col md:flex-row justify-between']">
    <slot></slot>
  </section>
</template>
<script>
export default {
  name: 'ContainerComponent'
}
</script>